import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Context } from '../config/store';
import { getLoggedInUser } from '../services/auth';

const Container = ({ children }) => {
	return (
		<>
			<Header />
			<section className='section h-100'>
				<div className='container-fluid pl-0 overflow-hidden'>
					<div className='row flex-row flex-nowrap h-100'>
						<input type='checkbox' id='handler' hidden />
						<div>
							<Sidebar />
						</div>

						<div className='main-container content-width overflow-scroll page_view' style={{ width: "100%", height: "", padding: "3px 16px", background: "#ffff" }}>
							<div className=''>

							</div>
							<div className=''>
								{children}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Container;
